import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import { FaCogs, FaCheck } from 'react-icons/fa';
import MiniLoadingSpinner from '../../../../../../../../../../../../../../../../components/Spinners/MiniLoadingSpinner';
import './ModifierListSection.scss';

interface ExistingModifier {
  modifier_id: number;
  modifier_name: string;
  modifier_description?: string;
  local_id: number;
  items_affected: Array<{
    item_id: number;
    item_name: string;
  }>;
  options_included: Array<{
    option_id: number;
    option_name: string;
    option_description?: string;
    price_modifier: number;
  }>;
  total_items_affected: number;
  total_options: number;
  has_price_modifiers: boolean;
  has_descriptions: boolean;
  options_with_descriptions: number;
}

interface ModifierListSectionProps {
  loading: boolean;
  filteredModifiers: ExistingModifier[];
  selectedModifier: ExistingModifier | null;
  onModifierSelect: (modifier: ExistingModifier) => void;
  searchTerm?: string;
}

const ModifierListSection: React.FC<ModifierListSectionProps> = ({
  loading,
  filteredModifiers,
  selectedModifier,
  onModifierSelect,
  searchTerm = ''
}) => {
  if (loading) {
    return (
      <div className="modifiers-loading-clean">
        <MiniLoadingSpinner />
        <p>Cargando modificadores disponibles...</p>
      </div>
    );
  }

  if (filteredModifiers.length === 0) {
    return (
      <div className="no-modifiers-message-clean">
        <FaCogs className="no-modifiers-icon-clean" />
        <h6>
          {searchTerm ? 'No se encontraron modificadores' : 'No hay modificadores disponibles'}
        </h6>
        <p>
          {searchTerm 
            ? 'Intenta con otros términos de búsqueda'
            : 'Crea nuevos modificadores para poder seleccionarlos aquí'
          }
        </p>
      </div>
    );
  }

  return (
    <div className="modifiers-list-section-clean">
      <div className="modifiers-grid-clean">
        {filteredModifiers.map(modifier => (
          <Card 
            key={modifier.modifier_id}
            className={`modifier-card-clean ${selectedModifier?.modifier_id === modifier.modifier_id ? 'selected' : ''}`}
            onClick={() => onModifierSelect(modifier)}
          >
            <Card.Body>
              <div className="modifier-header-clean">
                <div className="modifier-info-clean">
                  <h6 className="modifier-name-clean">{modifier.modifier_name}</h6>
                  {modifier.modifier_description && (
                    <p className="modifier-description-clean">
                      {modifier.modifier_description}
                    </p>
                  )}
                </div>
                {selectedModifier?.modifier_id === modifier.modifier_id && (
                  <FaCheck className="selected-icon-clean" />
                )}
              </div>
              
              <div className="modifier-options-preview-clean">
                <div className="options-badges-clean">
                  {modifier.options_included.slice(0, 3).map(option => (
                    <Badge key={option.option_id} className="option-badge-clean">
                      {option.option_name}
                    </Badge>
                  ))}
                  {modifier.options_included.length > 3 && (
                    <Badge className="more-options-badge-clean">
                      +{modifier.options_included.length - 3} más
                    </Badge>
                  )}
                </div>
              </div>
            </Card.Body>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ModifierListSection;
